import React from "react";

import SquaberLink from "../../../../../common/SquaberLink";
import classNames from "classnames";

export const IconButton = ({ onClick, icon, to, alt = "", childClassName }) => {
  const className =
    "bg-none b-none text-xs flex p-3 align-center rounded font-medium text-black hover:opacity-65";

  const child = icon ? (
    <img
      src={icon}
      alt={alt}
      width={24}
      height={24}
      className={classNames(childClassName, "shrink-0")}
    />
  ) : null;

  if (to) {
    return (
      <SquaberLink to={to}>
        <div className={className} onClick={onClick}>
          {child}
        </div>
      </SquaberLink>
    );
  }

  return (
    <button className={className} onClick={onClick}>
      {child}
    </button>
  );
};
